/**
 * User sync — fires a hidden iframe to the sync URL returned in the ad response.
 *
 * Sync is a fire-and-forget browser ping; placement in the DOM doesn't matter.
 * It runs after the auction and cannot affect match rates for the current request —
 * it improves match rates on subsequent visits.
 *
 * The sync URL comes from the ad server response (sync_frame_url), keeping
 * the tag free of hardcoded endpoints.
 */

import logger from './debug.js';

const log = logger.for('sync');

/**
 * @param {string} url
 */
export function fireSyncFrame(url) {
  if (!url) return;
  const iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.style.cssText = 'display:none;width:0;height:0;border:0;position:absolute';
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);
  log.debug('sync frame fired', url);
}
